export default {
  h5_open: {
    value: 'h5_open',
    desc: '非微信环境浏览器中',
  },
  h5_wx: {
    value: 'h5_wx',
    desc: '微信环境浏览器中',
  },
  app: {
    value: 'app',
    desc: '患者端app webview中',
  },
  wxmini_healthy_mall: {
    value: 'wxmini_healthy_mall',
    desc: '微信小程序 社群小程序',
  },
  wxmini_main: {
    value: 'wxmini_main',
    desc: '微信小程序 春雨主小程序',
  },
};
